$(function () {
  const $share = $('#share');

  if (!iCreateObject.isSiteInICreateMode) {
    $('#shareDropdown li').last().addClass('last');
  } else {
    $('#shareDropdown').empty();
  }

  $share.find('#shareBtn').on('click', function () {
    if (isSiteinICreateMode()) {
      showNAMessage();
    } else {
      let isExpanded = $(this).attr('aria-expanded') === 'true' ? true : false;

      $(this).attr('aria-expanded', isExpanded ? 'false' : 'true');

      isExpanded ? remove_trap_focus($share, 'shareTrap') : trap_focus($share, 'shareTrap');
    }
  });

  // Override the share links to current URL
  var curpage = encodeURIComponent(window.location);
  var curPageHeading = $(document).find('h1').length ? $.trim($('h1').text()).replace(/\s\s+/g, ' ') : $.trim($(document).find('title').text());

  $share.find('#fbShare').attr('href', 'https://www.facebook.com/sharer.php?u=' + curpage);
  $share.find('#liShare').attr('href', 'https://www.linkedin.com/shareArticle?mini=true&url=' + curpage);
  $share.find('#twShare').attr('href', 'https://www.twitter.com/intent/tweet?text=Check+out+ ' + curPageHeading + ' ' + curpage);
});